import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as video from './scripts/video';
video.init();

import * as iframeModifier from './scripts/iframe-modifier';
iframeModifier.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();